import { environment, unleashConfig } from '@/config';

function customFetch(url: string | URL, init?: RequestInit): Promise<Response> {
  const nextRequestInit: RequestInit = { ...(init ?? {}) };
  const headers = new Headers(nextRequestInit.headers);
  headers.set('X-UI-AppName', 'Comet');
  nextRequestInit.headers = headers;
  return fetch(url, nextRequestInit);
}

export default {
  url: unleashConfig.url,
  appName: unleashConfig.appName,
  fetch: customFetch,
  clientKey: unleashConfig.clientKey,
  disableMetrics: true,
  usePOSTrequests: true,
  environment: environment === 'production' ? 'production' : 'development'
};
